export enum ScribeErrorCode {
  HANDLER_ERROR = 'HANDLER_ERROR',
  SEND_ERROR = 'SEND_ERROR',
  TIMEOUT_ERROR = 'TIMEOUT_ERROR',
  RUNTIME_ERROR = 'RUNTIME_ERROR',
  INVALID_MESSAGE = 'INVALID_MESSAGE',
  NO_HANDLER = 'NO_HANDLER',
}

export class ScribeError extends Error {
  constructor(
    message: string,
    public code: ScribeErrorCode,
    public originalError?: unknown,
  ) {
    super(message);
    this.name = 'ScribeError';
  }

  toJSON() {
    return {
      name: this.name,
      message: this.message,
      code: this.code,
      stack: this.stack,
    };
  }
}

export function createScribeError(error: unknown, code: ScribeErrorCode): ScribeError {
  if (error instanceof ScribeError) {
    return error;
  }

  if (error instanceof Error) {
    return new ScribeError(error.message, code, error);
  }

  return new ScribeError(String(error), code, error);
}
